import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ProjectCard } from '../../../../components/ProjectCard';
import { ProjectsList } from '../../../../components/ProjectsList';
import { Section } from '../../../../components/Section';
import { selectBuilderInfo } from '../../../../selectors/builder';
import { IHouseView } from '../../../../types/builder';
import { CollapsedListContainer } from '../../../CollapsedListContainer';
import { HOUSES_COUNT } from './constants';
import { trackShowMoreHouses } from './tracking';

export interface IHousesListContainerProps {
  houses: IHouseView[];
  onHouseClick(house: IHouseView): void;
}

export const HousesListContainer: React.FC<IHousesListContainerProps> = ({ houses, onHouseClick }) => {
  const builderInfo = useSelector(selectBuilderInfo);

  const handleExpandList = useEventCallback(() => {
    trackShowMoreHouses(builderInfo.id);
  });

  const renderItem = useEventCallback((house: IHouseView, index: number) => {
    return <ProjectCard key={index} {...house} onClick={() => onHouseClick(house)} />;
  });

  const renderList = useEventCallback((children: React.ReactNode) => {
    return <ProjectsList>{children}</ProjectsList>;
  });

  return (
    <Section>
      <CollapsedListContainer
        list={houses}
        collapsedLength={HOUSES_COUNT}
        expandCount={HOUSES_COUNT}
        renderItem={renderItem}
        renderList={renderList}
        onExpand={handleExpandList}
      />
    </Section>
  );
};
